import React, { Component } from 'react';
// import { inject, observer } from 'mobx-react';
import ManualMitigationFormDialog from 'app/views/protect/mitigations/ManualMitigationFormDialog';

import { Button } from 'core/components';

export default class MitigateAlertButton extends Component {
  state = {
    showDialog: false
  };

  get initValues() {
    const { alertModel, tenant } = this.props;
    const values = { comment: `Alert: ${alertModel.id}` };
    const alertKey = alertModel?.dimensionToKeyPart?.IP_dst || alertModel?.dimensionToKeyPart?.IP_src;

    if (alertKey) {
      values.alertKey = alertKey;
    }

    if (tenant?.id) {
      values.tenantID = tenant.id;
    }

    return values;
  }

  handleOpenDialog = () => this.setState({ showDialog: true });

  handleCloseDialog = () => this.setState({ showDialog: false });

  render() {
    const { showDialog } = this.state;

    return (
      <>
        <Button icon="shield" textAlign="left" onClick={this.handleOpenDialog}>
          Start Manual Mitigation&hellip;
        </Button>
        {showDialog && (
          <ManualMitigationFormDialog
            isOpen={showDialog}
            onClose={this.handleCloseDialog}
            initValues={this.initValues}
          />
        )}
      </>
    );
  }
}
